import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Hero,
  PorQueEsteTaller,
  Programa,
  Speakers,
  ValoresAgregados,
  InversionRegistro,
  FooterTaller,
} from './components';

const LandingMediaKitTallerProduccion = ({ themeMode = 'light' }) => {
  return (
    <Box>
      <Container>
        <Hero themeMode={themeMode} />
      </Container>
      <Box bgcolor="alternate.main">
        <Container>
          <PorQueEsteTaller />
        </Container>
      </Box>
      <Container>
        <Programa />
      </Container>
      <Box bgcolor="alternate.main">
        <Container>
          <Speakers />
        </Container>
      </Box>
      <Container>
        <ValoresAgregados />
      </Container>
      <Container>
        <InversionRegistro />
      </Container>
      <Container>
        <FooterTaller />
      </Container>
    </Box>
  );
};

LandingMediaKitTallerProduccion.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingMediaKitTallerProduccion;
